import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useNotification } from '../../contexts/NotificationContext';
import { authFetch } from '../../utils/authFetch';
import { getImageUrl } from '../../firebase/storageService';
import PageLoader from '../../components/PageLoader';

export default function DetalhesFaltasReposicoes() {
    const { id } = useParams();

    const [faltas, setFaltas] = useState([]);
    const [reposicoes, setReposicoes] = useState([]);
    const [loading, setLoading] = useState(true);
    const { showNotification } = useNotification();
    const [imagem, setImagem] = useState(null);

    useEffect(() => {
        const fetchReposicoes = async () => {
            try {
                const response = await authFetch(`appointment/rescheduling-details/patient/${id}`);
                const data = await response.json();

                // Busca da imagem do paciente
                const url = await getImageUrl('patient', id);
                setImagem(url);

                setFaltas(data.absencesRescheduling || []);
                setReposicoes(data.reschedulingDone || []);
            } catch (error) {
                showNotification('danger', 'Erro ao buscar dados de reposição');
            } finally {
                setLoading(false);
            }
        };

        fetchReposicoes();
    }, [id]);

    if (loading) return <PageLoader />;

    const renderTabela = (lista) =>
        lista.map((item, index) => (
            <tr key={index}>
                <td className="text-xs mb-0">
                    <div className="d-flex px-2 py-1">
                        <div>
                            <img
                                src={imagem || require('../../assets/img/perfilvazio.png')}
                                alt="Paciente"
                                className="avatar avatar-sm me-3"
                                style={{ borderRadius: '1.75em' }}
                            />
                        </div>
                        <div className="d-flex flex-column justify-content-center">
                            <p className="mb-0 text-sm">{item.patientName}</p>
                        </div>
                    </div>
                </td>
                <td className="text-xs mb-0">
                    <div className="px-2 py-1 text-center">
                        <p className="mb-0 text-sm">
                            {new Date(item.date).toLocaleString('pt-BR', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                            })}
                        </p>
                    </div>
                </td>
            </tr>
        ));

    return (
        <div className="content">
            <div className="card">
                <div className="card-body p-3">
                    <h3 className="font-weight-bolder mb-0">Detalhes</h3>

                    <div className="col-md-12 row">
                        <h5>Faltas</h5>
                        <div className="table-responsive">
                            <table className="table align-items-center mb-0">
                                <thead>
                                    <tr>
                                        <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Criança</th>
                                        <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">
                                            Data da Falta
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>{renderTabela(faltas)}</tbody>
                            </table>
                        </div>
                    </div>

                    <br />

                    <div className="col-md-12 row">
                        <h5>Reposições</h5>
                        <div className="table-responsive">
                            <table className="table align-items-center mb-0">
                                <thead>
                                    <tr>
                                        <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Criança</th>
                                        <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">
                                            Data da Reposição
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>{renderTabela(reposicoes)}</tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
